import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Header } from '../components/landing/Header';
import { Footer } from '../components/landing/Footer';
import { policyContent } from '../data/mock';

export default function PolicyPage() {
  const location = useLocation();
  const slug = location.pathname.replace('/', '');
  const policy = policyContent[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!policy) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="pt-28 pb-20 px-6 lg:px-8 text-center">
          <h1 className="text-2xl font-bold text-stone-900 mb-4">
            Page Not Found
          </h1>
          <Link to="/">
            <Button variant="outline" className="border-stone-300 text-stone-700">
              <ArrowLeft className="mr-2 w-4 h-4" />
              Back to Home
            </Button>
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-28 pb-20 px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-stone-700 transition-colors duration-200 mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>

          <h1 className="text-3xl font-bold text-stone-900 mb-2">
            {policy.title}
          </h1>
          <p className="text-sm text-stone-400 mb-10">
            Last updated: {policy.lastUpdated}
          </p>

          <div className="space-y-8">
            {policy.sections.map((section, i) => (
              <div key={i}>
                <h2 className="text-lg font-semibold text-stone-800 mb-3">
                  {section.heading}
                </h2>
                <p className="text-sm text-stone-500 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <p className="text-sm text-stone-400">
              If you have any questions about this policy, please contact us at{' '}
              <a
                href="mailto:support@pyauditsystems.com"
                className="text-amber-600 hover:text-amber-700 font-medium"
              >
                support@pyauditsystems.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
